import buttonRadar from '../shared/button-radar.vue'
import back from '../shared/back.vue'

export default  {

  name: 'panel',

  components: {

    buttonRadar,
    back

  },

  data() {
    return {

      showBack: false,
      showRadar: false,
      showPanel: false,

    }
  },


  methods: {

    //Video doesnt autoplay on Mobile devices, so lets fake a tap
    play(){

      setTimeout(function () {

        let playVideo = document.getElementById("screensaver-video");
        playVideo.play();

      }, 500);

    }

  },

  mounted(){

    localStorage.setItem('play', false);

    let vue = this;

    let video = document.getElementById("screensaver-video");

    let player = document.getElementById("player");

    var e = new Event('touchstart');
    player.dispatchEvent(e);


    setTimeout(function () {

      vue.showPanel = true;

      vue.showRadar = true;

      vue.showBack = true;

    }, 5000);

  }

}




// WEBPACK FOOTER //
// ./src/components/hive/hive.component.js